// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalRoot_modal__4vLrS","content":"ModalRoot_content__uE2n6","icon":"ModalRoot_icon__DqXok"};